import { svg as t } from "lit";
import { IDSIconBase as r } from "../icon-base-element.js";
class o extends r {
  constructor() {
    super(), this.vbHeight = 12, this.vbWidth = 7;
  }
  renderIcon() {
    return t`<g><path fill="${this.colors.color}" d="M4.1627 5.57692L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683418 0.292893 0.292893C0.683418 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6.28403 4.86982C6.67456 5.26034 6.67455 5.89351 6.28402 6.28404L1.7071 10.8609C1.31657 11.2514 0.683406 11.2514 0.292886 10.8608C-0.0976345 10.4703 -0.0976276 9.83715 0.292901 9.44663L4.1627 5.57692Z"></path></g>`;
  }
}
export { o as IDSIconChevronBold };